module.exports = {"pyme":{"title":"PYME Program","text":"<p>OPEN HEALTHCARE, S.L. \nhas been a beneficiary of European Funds, whose objective is to improve the competitiveness of SMEs, and thanks to which it has launched an Action Plan with the aim of promoting the safe and reliable use of cyberspace and the competitiveness of SMEs during \nthe year 2024. For this, it has had the support of the Cybersecurity SME Program of the Seville Chamber of Commerce."}}


//////////////////
// WEBPACK FOOTER
// ./src/lang/en/public/views/pyme.json
// module id = 606
// module chunks = 120